import { createContext } from 'react';

const CarouselContext = createContext({
  carouselId: null,
  captionEnabled: true,
  captionPosition: 'bottom',
  captionAppearance: 'static'
});

export default CarouselContext;
